import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolBar: {
      display: 'flex',
      backgroundColor: '#FFF',
      borderBottom: '1px solid #dbdbdb',
    },
    wrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'auto',
      zIndex: 0,
    },
    wrapperBox: {
      flex: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      // minWidth: 400,
      maxWidth: 500,
      backgroundColor: '#F9F9F7',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },
  }),
);

export default useStyles;
